/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3dvcmxkLXJhbmtpbmctc3RhdGlzdGljcy93b3JsZC1yZWNvcmRzL2NvbXBvbmVudHMvZmlsdGVycy13b3JsZC1yZWNvcmRzL2ZpbHRlcnMtd29ybGQtcmVjb3Jkcy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
